<div class="flex h-screen w-full items-center justify-center bg-white dark:bg-vivid-royal-950">
  <div class="w-full max-w-md px-6 py-10">

    <!-- Logo -->
    <div class="mb-8 text-center">
      <img src="./assets/logos/energo_logo.svg" class="mx-auto w-40 dark:hidden" alt="Logo" />
      <img src="./assets/logos/energo_logo_dark.svg" class="mx-auto w-40 hidden dark:block" alt="Logo" />
    </div>

    <!-- Loading -->
    @if(enProceso) {
      <div class="text-center py-10">
        <i class="pi pi-spin pi-spinner text-2xl text-vivid-royal-400"></i>
        <p class="text-sm text-vivid-royal-400 mt-3">Procesando bloqueo...</p>
      </div>
    }

    <!-- Success -->
    @if(showResponse && showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-lock text-3xl text-green-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Cuenta bloqueada temporalmente</h1>
        <p class="text-sm text-vivid-royal-400">Para reactivar tu cuenta, comunícate al número de Atención a Clientes <a [href]="contact?.phoneLink" class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200 underline">{{ contact?.phone }}</a>.</p>
      </div>
    }

    <!-- Error -->
    @if(showResponse && !showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-times text-3xl text-red-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Bloqueo no exitoso</h1>
        <p class="text-sm text-vivid-royal-400">Intente de nuevo o contacte a Atención a Clientes.</p>
      </div>
    }

    <!-- Block button -->
    @if(!showResponse && !enProceso && !showOtp) {
      <div class="text-center space-y-6">
        <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-shield text-2xl text-red-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Bloqueo de cuenta</h1>

        <div class="bg-red-50 dark:bg-red-900/20 border border-red-300 dark:border-red-700 rounded-lg p-4 text-left space-y-2">
          <div class="flex items-start gap-2">
            <i class="pi pi-exclamation-triangle text-red-500 mt-0.5"></i>
            <div class="text-xs text-red-700 dark:text-red-300 space-y-1">
              <p class="font-semibold">Al desactivar temporalmente tu cuenta:</p>
              <ul class="list-disc ml-4 space-y-0.5">
                <li>Nadie podrá iniciar sesión en el portal con tu cuenta</li>
                <li>No será posible realizar cargas de combustible</li>
                <li>Podrás reactivar tu cuenta comunicándote al <a [href]="contact?.phoneLink" class="font-semibold underline">{{ contact?.phone }}</a></li>
              </ul>
            </div>
          </div>
        </div>

        <button pButton label="Proceder al bloqueo" icon="pi pi-lock" class="p-button-danger p-button-sm w-full" (click)="sendRequestBlock()"></button>
      </div>
    }
  </div>
</div>

@if(showOtp) {
  <app-auth-code-form-user [phoneNumber]="''" [email]="''" [clientNumber]="client" [dialcode]="'52'"
    (closeModal)="closeForm($event)" [IsPhone]="true" (validate)="closeForm($event)" [isRecovery]="false"
    [isBlock]="true" [info]="token">
  </app-auth-code-form-user>
}
